import { Injectable, Injector, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, ValidationErrors, ValidatorFn, AbstractControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class validationmethod implements OnInit {
    FormValid: UntypedFormGroup;
    constructor(private snackbar: MatSnackBar) {}
    ngOnInit() {

    }
    //Validating all form fields
    validateAllFormFields(formGroup: UntypedFormGroup) {         //{1}
        Object.keys(formGroup.controls).forEach(field => {  //{2}
            const control = formGroup.get(field);             //{3}
            if (control instanceof UntypedFormControl) {             //{4}
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof UntypedFormGroup) {        //{5}
                this.validateAllFormFields(control);            //{6}
            }
        });
    }

    //validation checking type 1
    getFormValidationErrors() {
        Object.keys(this.FormValid.controls).forEach(key => {
            const controlErrors: ValidationErrors = this.FormValid.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {

                });
            }
        });
    }

    getvalidationmessage() {
        this.snackbar.open("All mandatory fields to be filled ", "OK", {
            duration: 5000,
        });
    }
    /**
     * Author-Asha Waghadure
     * added to emailids validation message
     * Date 01-07-2024
     * @param emailids 
     */
     getemailvalidationmessage(emailids) {
        this.snackbar.open("Please enter valid email , invalid emailIds: "+emailids, "OK", {
            duration: 5000,
        });
    }

    materialQuantitygetValidationMsg() {
        this.snackbar.open("Dispatch quantity should not be greater than available quantity ", "OK", {
            duration: 5000,
        });
    }

    materialQtygetValidationMsg() {
        this.snackbar.open("Dispatch quantity should not be greater than MR quantity ", "OK", {
            duration: 5000,
        });
    }

    /*public noWhitespaceValidator(control: UntypedFormControl) {
          // Ensure value is a string before calling trim()
        const value = control.value ? control.value.toString() : '';
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'whitespace': true };
    }*/

    public noWhitespaceValidator(control: UntypedFormControl) {
        // Ensure value is a string before calling trim()
        const value = control.value ? control.value.toString() : '';
        const isWhitespace = value.trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'whitespace': true };
    }
    

    equalto(field_name): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {

            let input = control.value;

            let isValid = control.root.value[field_name] == input
            if (!isValid)
                return { 'equalto': { isValid } }
            else
                return null;
        };
    }

  /**
   * Modified by Manit Kumar
   * Date: 26-07-2024
   * Adding method to validate the Special Characters
   */
    public specialCharacterValidator(control: UntypedFormControl) {
      const forbiddenChars = /[<>()'"/\\*;:=\{\}`%+\^!]/;
      const hasForbiddenChars = forbiddenChars.test(control.value);
      return hasForbiddenChars ? { 'specialCharacter': true } : null;
    }
    
    
    //this method will japanese character also
    // Date 11-04-2025
  public restrictAllSpecialCharactersExceptHyphenAndUnderscore(control: UntypedFormControl) {
      const forbiddenChars = /[^\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Han}a-zA-Z0-9 _-]/u;
      return forbiddenChars.test(control.value) ? { 'specialCharacter': true } : null;
  }
  /**
   *  Author-Asha Waghadure
     * added to validate comma separated multiple emailids 
     * Date 01-07-2024
   * @param field_name 
   * @returns 
   */
 public commaSeparatedEmailsValidator(field_name) {
    const value = field_name.value ? field_name.value.toString().trim() : '';
    if (!value) return null; 

     const emails = value.split(',').map(e => e.trim());

     const invalidEmails = emails.filter(email => {
        const emailControl = new UntypedFormControl(email);
        const isEmailInvalid = Validators.email(emailControl) !== null;
        const hasDomainSuffix = /\.[a-z]{2,}$/.test(email); 
        return isEmailInvalid || !hasDomainSuffix;
      });    
    return invalidEmails.length>0 ? {'invalidEmails':invalidEmails }:null;
}
/**
 * author-Asha Waghadure
 * Date-03-07-2024
 * used for validation of otp
 */
 getotpvalidationmessage() {
        this.snackbar.open("please enter valid OTP ", "OK", {
            duration: 5000,
        });
    }





}
